export default __webpack_public_path__ + "static/media/guia-1-0.3ff95037.svg";